<script lang="ts">
    import TrackingListField from "../../widgets/fields/TrackingListField.svelte"
    import { tooltip } from "../../../helper"
    import { _ } from "svelte-i18n"

    export let position: OperationPosition

    let count = position.tracking?.length || 0
    let deliveredCount = 0
    position.tracking?.forEach((t) => {
        if (t.status >= 99) deliveredCount++
    })
</script>

<span class="label">{$_("components.table.fields.trackingField.trackingLabel")}</span>
{#if count}
    <span class="table_icon {deliveredCount < count ? 'yellow' : 'green'}">
        <span class="material-icons">local_shipping</span>
    </span>
    <span class="text">
        <span>
            {$_("components.table.fields.trackingField.deliveredStatus", {
                values: {
                    deliveredCount,
                    count,
                },
            })}
        </span>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <span
            on:click|stopPropagation
            use:tooltip="{{
                content: {
                    component: TrackingListField,
                    props: {
                        position,
                    },
                },
                className: 'tracking_overlay',
                when: 'click',
            }}"
        >
            {$_("components.table.fields.trackingField.showDetails")}
            <span class="material-icons">chevron_right</span>
        </span>
    </span>
{:else}
    <span>{$_("components.table.fields.trackingField.notAvailable")}</span>
{/if}
